import axios from 'axios'

export default  {
  namespaced: true,

  state: {
    customers: null,
  },

  mutations: {
    getCustomersSuccess(state, customers) {
      state.customers = customers
    },
  },

  actions: {
    getCustomers({commit}) {
      return new Promise((resolve, reject) => {
        axios
          .get('/medico/customers/all')
          .then(res => {
            commit('getCustomersSuccess', res.data.data.datas)
            resolve(true)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    getPatientData({commit}, patientId) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/medico/patients/${patientId}/data`)
          .then(res => {
            resolve(res.data.data.patient)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    getSectionsData({commit}, serviceId) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/medico/services/${serviceId}/sections`)
          .then(res => {
            resolve(res.data.data.sections)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    saveSchedule({commit}, data) {
      return new Promise((resolve, reject) => {
        axios
          .post('/medico/schedules', data)
          .then(res => {
            resolve(res)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
  },

  getters: {
    customers: (state) => state.customers,
  },
}
